import { render, staticRenderFns } from "./AmostrasStatusUmidade.vue?vue&type=template&id=39088391&"
import script from "./AmostrasStatusUmidade.vue?vue&type=script&lang=ts&"
export * from "./AmostrasStatusUmidade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports